
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 8 12","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.438 8.307v-.193c.003-.663.062-1.192.176-1.586.117-.394.288-.712.511-.954.223-.243.492-.462.807-.66.235-.15.445-.308.63-.47.186-.164.334-.344.444-.54.11-.201.164-.425.164-.671 0-.261-.062-.49-.187-.688a1.248 1.248 0 00-.506-.454 1.506 1.506 0 00-.693-.16c-.246 0-.48.056-.699.166-.22.106-.4.265-.54.477-.14.208-.215.468-.227.778H0c.019-.757.2-1.382.545-1.875A3.124 3.124 0 011.915.37 4.68 4.68 0 013.795 0c.754 0 1.42.125 2 .375.58.246 1.035.604 1.364 1.074.33.47.494 1.036.494 1.699 0 .443-.073.837-.221 1.182a2.88 2.88 0 01-.608.909 4.71 4.71 0 01-.926.71c-.3.178-.546.364-.739.557-.19.193-.331.416-.426.67a2.89 2.89 0 00-.142.938v.193H2.437zm1.124 3.636c-.378 0-.702-.132-.971-.397a1.308 1.308 0 01-.392-.966c-.004-.372.127-.69.392-.955.269-.265.593-.398.971-.398.36 0 .677.133.95.398a1.304 1.304 0 01.215 1.642c-.125.205-.29.37-.494.494a1.291 1.291 0 01-.67.182z","fill":"currentColor"}})])
          )
        }
      }
    